export type NonEmptyArray<T> = [T, ...T[]];

export type EnumKeys<TEnum> = Extract<keyof TEnum, string>;

export type DeepPartial<T> = T extends string | number | bigint | boolean | null | undefined | symbol | Date
  ? T | undefined
  : T extends Array<infer ArrayType>
    ? Array<DeepPartial<ArrayType>>
    : T extends ReadonlyArray<infer ArrayType>
      ? ReadonlyArray<ArrayType>
      : T extends Set<infer SetType>
        ? Set<DeepPartial<SetType>>
        : T extends ReadonlySet<infer SetType>
          ? ReadonlySet<SetType>
          : T extends Map<infer KeyType, infer ValueType>
            ? Map<DeepPartial<KeyType>, DeepPartial<ValueType>>
            : T extends ReadonlyMap<infer KeyType, infer ValueType>
              ? ReadonlyMap<DeepPartial<KeyType>, DeepPartial<ValueType>>
              : {
                  [K in keyof T]?: DeepPartial<T[K]>;
                };

// Just like Partial<T> except all keys must be declared (want to make sure we don't forget any).
export type PartialWithAllKeys<T> = {
  [K in keyof T]: T[K] | undefined;
};

export function isDefined<T>(x: T | undefined | null): x is T {
  return x !== undefined && x !== null;
}

// Better typed versions of Object.keys and Object.entries

export function keys<K extends string>(obj: Record<K, any>): Array<K> {
  return Object.keys(obj) as Array<K>;
}

export function entries<K extends string, V>(obj: Record<K, V>): Array<[K, V]> {
  return Object.entries(obj) as Array<[K, V]>;
}

export function assertUnreachable(x: never): never {
  throw new Error(`Did not expect value '${x}'`);
}

// A non-interrupting version of assertUnreachable above
// When you want the compile-time check without the runtime failure.
export function warnUnreachable(x: never): void {
  console.warn(`Did not expect value '${x}'`);
}
